import React from 'react'
import PropTypes from 'prop-types'
import { ToastContainer } from 'react-toastify'

import RouteHandler from 'components/RouteHandler'
import AppProvider from 'components/AppProvider'
import { NetworkMonitor } from 'components/NetworkMonitor'
import { AppErrorBoundary } from 'modules/ErrorHandling'
import LDProvider from 'contexts/LDProvider'
import { FlagsProvider } from 'contexts/Flags'
import { CableProvider } from 'contexts/cable'

import 'react-toastify/dist/ReactToastify.min.css'
import 'styles/common.inline.scss'

export const App = ({ store, client, ...propsFromRails }) => (
  <NetworkMonitor>
    <AppProvider client={client} store={store}>
      <AppErrorBoundary>
        <LDProvider>
          <FlagsProvider>
            <CableProvider>
              <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                closeButton={false}
                draggable={false}
                newestOnTop
                closeOnClick
                pauseOnHover
              />
              <RouteHandler propsFromRails={propsFromRails} />
            </CableProvider>
          </FlagsProvider>
        </LDProvider>
      </AppErrorBoundary>
    </AppProvider>
  </NetworkMonitor>
)

App.propTypes = {
  client: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  store: PropTypes.shape({
    dispatch: PropTypes.func.isRequired,
    getState: PropTypes.func.isRequired,
    replaceReducer: PropTypes.func.isRequired,
    subscribe: PropTypes.func.isRequired,
  }).isRequired,
}

export default App
